/** What the voice widget shows for the agent's state (#1824). */

export type VoiceView = 'idle' | 'connecting' | 'listening' | 'processing' | 'speaking' | 'muted' | 'errorMic' | 'errorNet'

const MICROPHONE_ERRORS = ['NotAllowedError', 'NotFoundError', 'NotReadableError', 'SecurityError']

export function voiceView(
  status: 'disconnected' | 'connecting' | 'connected' | 'listening' | 'speaking' | 'processing',
  isMuted: boolean,
  error: Error | null,
): VoiceView {
  if (status === 'disconnected') {
    if (!error) return 'idle'
    return MICROPHONE_ERRORS.includes(error.name) ? 'errorMic' : 'errorNet'
  }
  if (status === 'connecting') return 'connecting'
  if (isMuted) return 'muted'
  if (status === 'speaking' || status === 'processing') return status
  return 'listening'
}
